import User from "./User";

/**
 * Base visibility.
 */
export class Visibility {
  readonly teamIds: string[] = [];
  readonly roleIds: string[] = [];

  constructor(deriveFrom?: Partial<Visibility>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }

  isVisible(currentUser: User) {
    if (!currentUser) {
      return null;
    }
    
    if (currentUser.isAdmin) {
      return true;
    }

    if (!currentUser.teamIds.find(teamId => this.teamIds.includes(teamId))) {
      return false;
    }

    //  Roller inom valda team.
    if (this.roleIds.length && !this.roleIds.find(roleId => currentUser.roleIds.includes(roleId))) {
      return false;
    }

    return true;
  }
}